export class Quantity {
  public static PRESSURE = "Pressure";
  public static SPEED = "Speed";
  public static THROUGHPUT = "Throughput";
  public static POWER = "Power";
  public static FREQUENCY = "Frequency";
  public static LENGTH = "Length";
  public static XDIM = "XDim";
  public static THROUGHPUT_MASS_FLOW = "Throughput Mass Flow";
  public static THROUGHPUT_MOLAR_FLOW = "Throughput Molar Flow";
  public static VOLUME = "Volume";
  public static AREA = "Area";
  public static TIME = "Time";
  public static TEMPERATURE = "Temperature";
  public static OUTGASSING = "Outgassing";
}

export class Preset {
  public static PRESET_EUROPEAN = "European";
  public static PRESET_US = "US";
  public static PRESET_SI = "SI";
  public static PRESET_CUSTOM = "Custom";
  public static PRESET_EUROPEAN_SETTINGS = [
    [Quantity.THROUGHPUT, 'mbar\u00B7m\u00B3/h'],
    [Quantity.PRESSURE, 'mbar'],
    [Quantity.SPEED, 'm\u00B3/h'],
    [Quantity.XDIM, 'mm'],
    [Quantity.LENGTH, 'm'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'slm'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'kg/s'],
    [Quantity.VOLUME, 'l'],
    [Quantity.TEMPERATURE, '°C'],
    [Quantity.TIME, 's'],
    [Quantity.AREA,'m²'],
    [Quantity.POWER,'W'],
    [Quantity.OUTGASSING,'mbar.l/s/cm²'],
  ];
  public static PRESET_US_SETTINGS = [
    [Quantity.THROUGHPUT, 'Torr\u00B7ft\u00B3/min'],
    [Quantity.PRESSURE, 'Torr'],
    [Quantity.SPEED, 'ft\u00B3/min'],
    [Quantity.XDIM, 'in'],
    [Quantity.LENGTH, 'ft'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'slm'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'lb/hr'],
    [Quantity.VOLUME,'ft³'],
    [Quantity.TEMPERATURE, '°C'],
    [Quantity.TIME, 's'],
    [Quantity.AREA,'ft²'],
    [Quantity.POWER,'W'],
    [Quantity.OUTGASSING,'mbar.l/s/cm²'],
  ];

  public static PRESET_SI_SETTINGS = [
    [Quantity.THROUGHPUT, 'Pa\u00B7m\u00B3/s'],
    [Quantity.PRESSURE, 'Pa'],
    [Quantity.SPEED, 'm\u00B3/s'],
    [Quantity.XDIM, 'm'],
    [Quantity.LENGTH, 'm'],
    [Quantity.FREQUENCY, 'Hz'],
    [Quantity.THROUGHPUT_MOLAR_FLOW, 'mol/s'],
    [Quantity.THROUGHPUT_MASS_FLOW, 'kg/s'],
    [Quantity.VOLUME,'m³'],
    [Quantity.TEMPERATURE, 'K'],
    [Quantity.TIME, 's'],
    [Quantity.AREA,'m²'],
    [Quantity.POWER,'W'],
    [Quantity.OUTGASSING,'Pa.m/s'],
  ];

}

export class UnitSetting {
  _id?:string;
  userId?:string;
  pressure:string;
  throughput:string;
  throughputMolarFlow:string;
  throughputMassFlow:string;
  frequency:string;
  power:string;
  length:string;
  xDim:string;
  speed:string;
  preset?:string;
  area:string;
  volume:string;
  time:string;
  temperature:string;
  outgassing:string;
}